import React from "react";
import { MaintenancePage, MaintenanceWarning } from "pages/Maintenance";
import useMaintenance from "hooks/useMaintenance";
import PropTypes from "prop-types";
// import LazyLoadingSpinner from "./LazyLoadingSpinner";

export default function MaintenanceGate({ children }) {
  // eslint-disable-next-line no-unused-vars
  const { isActive, maintenanceWindow, upcoming, loading } = useMaintenance();

//   if (loading) {
//     return <LazyLoadingSpinner text="Checking maintainance..." />;
//   }

  if (isActive) {
    return <MaintenancePage window={maintenanceWindow} />;
  }

  return (
    <>
      {upcoming && <MaintenanceWarning upcoming={upcoming} />}
      {children}
    </>
  );
}

MaintenanceGate.propTypes = {
  children: PropTypes.node,
};